<template>
	<section class="inventory-container common-container" ref="inventorycontainer">
		<!--操作-->
		<section class="data-oper">
			<el-input placeholder="快速搜索" clearable v-model="vagueContent" style="float: right; width: 300px;" @change="searchList" @keyup.native="searchList">
				<el-button slot="append" icon="el-icon-search"></el-button>
			</el-input>
			<div style="float: right; width: 300px; margin-right: 20px;">
				<el-select v-model="inventoryStatus" clearable placeholder="请选择禁用、启用状态" @change="classFilter">
					<el-option
						v-for="item in inventoryStatusOptions"
						:key="item.key"
						:label="item.value"
						:value="item.key">
					</el-option>
				</el-select>
			</div>
			<div style="float: right; width: 300px; margin-right: 20px;">
				<el-select v-model="sortCode" clearable placeholder="请选择商品分类" @change="classFilter">
					<el-option
						v-for="item in allClassDatas"
						:key="item.code"
						:label="item.name"
						:value="item.code">
					</el-option>
				</el-select>
			</div>
			<el-button type="primary" @click="exportExcel" class="hzpbtn-primary">导出</el-button>
			<el-button type="primary" @click="syncCommodity" class="hzpbtn-primary">同步商品</el-button>
		</section>
		<!--列表-->
		<el-table :data="datas" :stripe="true" :height="containerHeight - 85" highlight-current-row v-loading="loading" id="out-table" class="data-content" border>
			<af-table-column label="序号" align="center" type="index" width="60">
				<template slot-scope="scope">
    				<span>{{ ((!!pageNum && !!pageSize)? ((pageNum - 1) * pageSize) : 0) + scope.$index + 1}}</span>
				</template>
			</af-table-column>
			<af-table-column prop="name" label="商品名称" align="center">
			</af-table-column>
			<af-table-column prop="code" label="  商品编号  " align="center">
			</af-table-column>
			<af-table-column prop="sortCode" label="商品分类" align="center">
			</af-table-column>
			<el-table-column prop="" label="图片" align="center">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.thumimage" fit="cover" v-show="!!scope.row.thumimage"></el-image>
				</template>
			</el-table-column>
			<af-table-column prop="ccomunitname" label="单位" align="center">
			</af-table-column>
			<af-table-column prop="refsaleprice" label="零售价" align="center">
			</af-table-column>
			<el-table-column prop="remark" label="备注" align="center" min-width="150">
			</el-table-column>
			<af-table-column label="操作" align="center" width="150" fixed="right">
				<template slot-scope="scope">
					<label class="hzpedit" @click.prevent="enableData(scope.$index, scope.row)">{{scope.row.status === 0? '禁用' : '启用'}}</label>|
					<label class="hzpedit" @click.prevent="editData(scope.$index, scope.row)">编辑</label>
				</template>
			</af-table-column>
		</el-table>
		<!--分页-->
		<pagination :pageSize="pageSize" :pageNum="pageNum" :totalNum="totalNum" 
			@handlePageSizeChange="handlePageSizeChange" @handlePageCurrentChange="handlePageCurrentChange">
		</pagination>
		<!--编辑数据-->
        <el-dialog :title="dialogTitle + '数据'" :visible.sync="editDialogVisible" class="dialog-container" width="500px" @opened="openDialog">
			<el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="form-data" size="mini">
				<el-form-item label="商品名称" prop="" >
					<el-input v-model="formData.name" placeholder="请输入" id="focus-ele" :disabled="codeDisabled"></el-input>
				</el-form-item>
				<el-form-item label="商品编号" prop="">
					<el-input v-model="formData.code" placeholder="请输入" :disabled="codeDisabled"></el-input>
				</el-form-item>
				<!-- <el-form-item label="商品分类" prop="">
					<el-select v-model="formData.class" placeholder="请选择">
						<el-option
							v-for="item in classDatas"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="单位" prop="">
					<el-input v-model="formData.ccomunitname" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="零售价" prop="">
					<el-input v-model="formData.retailprice" placeholder="请输入"></el-input>
				</el-form-item> -->
				<el-form-item label="图片" prop="">
					<UploadFile :imgUrl="formData.thumimage" @getFileUrl="getFileUrl" ref='UploadFile'></UploadFile>
				</el-form-item>
				<el-form-item label="备注" prop="">
					<el-input v-model="formData.remark" placeholder="请输入" type="textarea" :rows="4"></el-input>
				</el-form-item>
        	</el-form>
            <div slot="footer" class="dialog-footer">
              	<el-button @click="closeDialog" class="hzpbtn-close">关 闭</el-button>
                <el-button type="primary" @click="handleSubmit('formData')" v-loading="loading" class="hzpbtn-primary">保 存</el-button>
            </div>
        </el-dialog>
	</section>
</template>
<script>
	import { getInventoryClassList } from '../../api/api';
	import { getInventoryList } from '../../api/api';
	import { inventoryVague } from '../../api/api';
	import { addInventoryimage } from '../../api/api';
	import { editInventoryimage } from '../../api/api';
	import { enableInventory } from '../../api/api';
	import { updateInventory } from '../../api/api';
	import util from '../../common/js/util';
	import emEnum from '../../common/js/emEnum';
	// 分页组件
	import Pagination from '../Pagination';
	// 上传文件组件
	import UploadFile from '../UploadFile';

	export default {
		components: {
			Pagination,
			UploadFile
		},
		data() {
			return {
				sysCnName: emEnum.cnName,  // 中文名称
				sysEnName: emEnum.enName,  // 英文名称

				loginId: '',   // 登录用户

				loading: false,
				containerHeight: 0,
				datas: [],
				// 分页
				pageSize: 100,
				pageNum: 1,
        		totalNum: 0,

				inventoryStatusOptions: emEnum.inventoryStatusOptions,  // 商品状态可选项
				allClassDatas: [], // 带全部的商品分类
				classDatas: [],    // 商品分类
				dialogTitle: '',   // 对话框标题
				dialogBtnVal: '',  // 按钮值
				editDialogVisible: false,  // 编辑对话框
				codeDisabled: true,  // 编号不可编辑
				
				sortCode: '',        // 搜索分类
				inventoryStatus: '', // 商品状态
				oldVagueContent: '', // 原快速搜索内容
				vagueContent: '',    // 快速搜索内容

				formData: {
					id: '',        // 选中ID
					name: '',      // 商品名称
					code: '',      // 商品编号
					classid: '',   // 分类ID
					ccomunitname: '',  // 单位
					retailprice: '',   // 零售价
					highimage: '',	   // 高清图
					thumimage: '',     // 缩略图
					remark: ''         // 备注
				},
				rules: {
					username: [
						{ required: true, message: '请输入用户账号', trigger: 'blur' }
					],
					role: [
						{ required: true, message: '请选择用户角色', trigger: 'change' }
					],
					areaid: [
						{ required: true, message: '请选择所属区域', trigger: 'change' }
					]
				}
			}
		},
		methods: {
			// 用户角色显示转换
			formatRole: function (row, column) {
				let roleOp = emEnum.roleOptions.find(item=>{
					return item.key === row.role;
				});
				if(!roleOp) return '';
				else return roleOp.value;
			},
			// 时间显示格式转换
			formatCreatTime: function (row, column) {
				if(!!row.creattime) {
					return util.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
				} else return row.creattime;
			},
			// 搜索数据
			searchList: function () {
				let _this = this;
				if(_this.oldVagueContent !== _this.vagueContent) {
					_this.oldVagueContent = _this.vagueContent;
					// 如果有搜索数据，则模糊搜索
					if(!!_this.vagueContent) {
						// 执行操作
						_this.loading = true;
						_this.closeDialog();  // 关闭编辑对话框
						let para = {
							vague: _this.vagueContent,
							pageNum: !!_this.pageNum? _this.pageNum : 1,
							pageSize: !!_this.pageSize? _this.pageSize : 100
						};
						// 如果有分类筛选值，则按分类筛选
						if(!!_this.sortCode) para['code'] = _this.sortCode;
						// 如果有状态筛选值，则按状态筛选
						if(_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;

						inventoryVague(para, _this)
						.then(res=>res.data)
						.then(data => {
							_this.loading = false;
							let { code, msg } = data;
							if (code !== "0") {
								_this.$message({
									message: msg,
									type: 'error'
								});
							} else {
								let { pageSize, pageNum, totalNum } = data.data;
								data = data.data.list;
								_this.datas = data;
								// 分页
								_this.pageSize = pageSize;
								_this.pageNum = pageNum;
								_this.totalNum = totalNum;
							}
						});
					} else {
						_this.getData();
					}
				}
			},
			// 分类筛选
			classFilter: function () {
				let _this = this;
				if(!!_this.vagueContent) {
					_this.searchList();
				} else {
					_this.getData();
				}
			},
			// 获取列表
			getData: function () {
				let _this = this;
				// 执行操作
				_this.loading = true;
				_this.closeDialog();  // 关闭编辑对话框
				let para = {
					pageNum: !!_this.pageNum? _this.pageNum : 1,
					pageSize: !!_this.pageSize? _this.pageSize : 100
				};
				// 如果有分类筛选值，则按分类筛选
				if(!!_this.sortCode) para['sortCode'] = _this.sortCode;
				// 如果有状态筛选值，则按状态筛选
				if(_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;

				getInventoryList(para, _this)
				.then(res=>res.data)
				.then(data => {
					_this.loading = false;
					let { code, msg } = data;
					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						let { pageSize, pageNum, totalNum } = data.data;
						data = data.data.list;
						_this.datas = data;
						// 分页
						_this.pageSize = pageSize;
						_this.pageNum = pageNum;
						_this.totalNum = totalNum;
					}
				});
			},
			// 修改数据状态（禁用、启用）
			enableData: function (index, row) {
				let _this = this;
				_this.$confirm('确认' + (row.status === 0? '禁用' : '启用') + '该库存？', '提示', {
					type: 'warning'
				}).then(() => {
					_this.loading = true;
					let para = {
						code: row.code,
						status: row.status === 0? '1' : '0'
					};
					enableInventory(para, _this)
					.then(res=>res.data)
					.then(data => {
						_this.loading = false;
						let { msg, code } = data;
						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch((error) => {
					if(error!=='cancel') {
						_this.$message({
							message: error.message? error.message : error,
							type: 'error'
						});
					}
				});
			},
			// 重置输入
			resetForm: function (formName) {
				this.$refs[formName].resetFields();
			},
			// 编辑数据
			editData: function (index, row) {
				let formName = 'formData';
				// 打开对话框
				this.editDialogVisible = true;
				// 默认值
				if(!row) {
					this.dialogTitle = "添加";
					this.dialogBtnVal = "上传图片";
					if(this.$refs[formName]) this.$refs[formName].resetFields();
					this.formData.name = "";
					this.formData.code = "";
					// // 商品分类选中第一个
					// if(!!this.classDatas && this.classDatas.length > 0) {
					// 	this.formData.classid = this.classDatas[0].id;
					// }
					// this.formData.ccomunitname = "";
					// this.formData.retailprice = "";
					this.formData.highimage = "";
					this.formData.thumimage = "";
					this.formData.remark = "";
				} else {
					this.dialogTitle = "编辑";
					this.dialogBtnVal = "重新上传";
					this.formData.id = row.id;
					this.formData.name = row.name;
					this.formData.code = row.code;
					// this.formData.classid = "";      // 没有字段
					// this.formData.ccomunitname = row.ccomunitname;
					// this.formData.retailprice = "";  // 没有字段
					this.formData.highimage = row.highimage;
					this.formData.thumimage = row.thumimage;
					this.formData.remark = row.remark;
					
					// 校验输入
					//if(this.$refs[formName]) this.$refs[formName].validate();
				}
			},
			// 打开编辑对话框
			openDialog: function () {
				// 改变组件的图片地址和按钮值
				this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);
				// 焦点放到获取焦点的输入框
				let ele = document.getElementById('focus-ele');
				if(!!ele) {
					ele.focus();
				}
			},
			// 关闭编辑对话框
			closeDialog: function () {
				this.editDialogVisible = false;
			},
			// 提交数据
			handleSubmit: function (formName) {
				this.$refs[formName].validate((valid) => {
          			if (valid) {
						let _this = this;
						_this.$confirm('确认' + _this.dialogTitle + '库存图片？', '提示', {
							type: 'warning'
						}).then(() => {
							_this.loading = true;
							if(!_this.formData.code) {  // 添加
								let para = {
									inventorycode: _this.formData.code,
									highimage: _this.formData.highimage,
									thumimage: _this.formData.thumimage,
									remark: _this.formData.remark,
								};
								addInventoryimage(para, _this)
								.then(res=>res.data)
								.then(data => {
									_this.loading = false;
									let { msg, code } = data;
									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										_this.$message({
											message: msg,
											type: 'success'
										});
										_this.getData();
									}
								});
							} else {  // 编辑数据
								let para = {
									inventorycode: _this.formData.code,
									highimage: _this.formData.highimage,
									thumimage: _this.formData.thumimage,
									remark: _this.formData.remark,
								};
								editInventoryimage(para, _this)
								.then(res=>res.data)
								.then(data => {
									_this.loading = false;
									let { msg, code } = data;
									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										_this.$message({
											message: msg,
											type: 'success'
										});
										_this.getData();
									}
								});
							}
						}).catch((error) => {
							if(error!=='cancel') {
								_this.$message({
									message: error.message? error.message : error,
									type: 'error'
								});
							}
						});
					} else {
						return false;
					}
				});
			},
			// 导出Execl
			exportExcel: function () {
				let _this = this;
				// 获取所有商品
				_this.loading = true;
				_this.closeDialog();  // 关闭编辑对话框
				let para = {
					pageNum: 1,
					pageSize: _this.totalNum
				};
				// 如果有状态筛选值，则按状态筛选
				if(_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;
				// 如果有搜索数据，则模糊搜索
				if(!!_this.vagueContent) {
					para['vague'] = _this.vagueContent;
					// 如果有分类筛选值，则按分类筛选
					if(!!_this.sortCode) para['code'] = _this.sortCode;
					inventoryVague(para, _this)
					.then(res=>res.data)
					.then(data => {
						_this.loading = false;
						let { code, msg } = data;
						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							data = data.data.list;
							_this.doExport(data);
						}
					});
				} else {
					// 如果有分类筛选值，则按分类筛选
					if(!!_this.sortCode) para['sortCode'] = _this.sortCode;
					getInventoryList(para, _this)
					.then(res=>res.data)
					.then(data => {
						_this.loading = false;
						let { code, msg } = data;
						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							data = data.data.list;
							_this.doExport(data);
						}
					});
				}
			},
			// 执行导出
			doExport: function (tabData) {
				if(!!tabData && tabData.length > 0) {
					let i = 1;
					tabData.forEach(item => {
						item.id = i;
						item.status = item.status === 0? '启用' : '禁用';
						item.refsaleprice = parseFloat(item.refsaleprice);
						i++;
					});
					// 获取文件名
					let fileName = this.sysCnName + "_" + util.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + this.$root.$route.name;
					// 表头和对应字段
					let tHeader = [ '序号', '商品名称', '商品编号', '商品分类', '单位', '零售价', '状态', '备注' ];
					let filterVal = [ 'id', 'name', 'code', 'sortCode', 'ccomunitname', 'refsaleprice', 'status', 'remark' ];
					util.exportJsonToExcel(fileName, JSON.stringify(tabData), tHeader, filterVal);
				} else {
					this.$message({
						message: "没有需要导出的数据",
						type: 'warning'
					});
				}
			},
			// 同步商品
			syncCommodity: function () {
				let _this = this;
				_this.$confirm('确认同步商品？', '提示', {
					type: 'warning'
				}).then(() => {
					_this.loading = true;
					let para = {};
					updateInventory(para, _this)
					.then(res=>res.data)
					.then(data => {
						let { code, msg } = data;
						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.loading = false;
							_this.$message({
								message: '同步商品成功！',
								type: 'info'
							});
						}
					});
				}).catch((error) => {
					if(error!=='cancel') {
						_this.$message({
							message: error.message? error.message : error,
							type: 'error'
						});
					}
				});
			},
			// 获取区域
			getAllClass: function () {
				let _this = this;
				_this.loading = true;
				let para = {};
				getInventoryClassList(para, _this)
				.then(res=>res.data)
				.then(data => {
					let { code, msg } = data;
					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.classDatas = data;  //.filter(item => item.status === 0);
						// 处理带全部的商品分类
						//_this.allClassDatas.push({code: '', name: '全部'});
						_this.classDatas.forEach(item => {
							_this.allClassDatas.push({code: item.code, name: item.name});
						});
						_this.loading = false;
					}
				});
			},
			// 获取文件路径
			getFileUrl: function (high, thum) {
				this.formData.highimage = high;
				this.formData.thumimage = thum;
			},
			// 分页事件
			handlePageSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			handlePageCurrentChange(val) {
				this.pageNum = val;
				this.getData();
			}
		},
		// 创建VUE实例后的钩子
		created: function () {
			// 登录ID
			this.loginId = util.userData.getLoginUserFieldValue(emEnum.loginUserFileds.uid, this);
			// 获取区域
			this.getAllClass();
		},
		// 挂载到DOM后的钩子
		mounted: function () {
			let _this = this;
			_this.containerHeight = _this.$refs.inventorycontainer.offsetHeight;
			// 获取参数值
			let query = _this.$route.query;
			_this.sortCode = query.code;
			// 获取用户
			_this.getData();
			// 绑定窗口尺寸改变事件改变数据表的高度
			window.onresize = () => {
				return (() => {
					// 为了避免频繁触发resize函数导致页面卡顿，使用定时器
					if (!this.timer && !!_this.$refs.inventorycontainer) {
						this.timer = true
						_this.containerHeight = _this.$refs.inventorycontainer.offsetHeight;
						let that = this
						setTimeout(function () {
							that.timer = false
						}, 100);
					}
				})();
			}
		}
	};
</script>

<style lang="scss">
.inventory-container {
	height: calc(100vh - 120px);
}
</style>


// WEBPACK FOOTER //
// Inventory.vue?492add9f